if (!customElements.get('sil-custom-size-field')) {
  customElements.define(
    'sil-custom-size-field',
    class SilCustomSizeField extends HTMLElement {
      connectedCallback() {
        this.productForm = this.closest('product-form');
        this.form = this.closest('form');
        this.variantInput = this.form && this.form.querySelector('input[name="id"]');
        this.input = this.querySelector('input[name="properties[Custom dimensions]"]');
        this.error = this.querySelector('.sil-custom-size-field__error');
        this.customVariantIds = String(this.dataset.customVariantIds || '')
          .split(',')
          .filter(Boolean);

        if (!this.form || !this.variantInput || !this.input) return;

        this.update = this.update.bind(this);
        this.validate = this.validate.bind(this);
        this.variantInput.addEventListener('change', this.update);
        this.input.addEventListener('input', () => {
          this.clearError();
          this.updatePaymentButtonState();
        });
        this.form.addEventListener('submit', this.validate, true);
        this.productForm?.addEventListener(
          'click',
          (event) => {
            if (!event.target.closest('.shopify-payment-button')) return;
            this.validate(event);
          },
          true
        );
        this.update();
      }

      requiresCustomSize() {
        return this.customVariantIds.includes(String(this.variantInput.value || ''));
      }

      update() {
        const active = this.requiresCustomSize();
        this.hidden = !active;
        this.input.required = active;
        this.input.disabled = !active;
        this.input.setAttribute('aria-required', String(active));
        if (!active) {
          this.clearError();
        }
        this.updatePaymentButtonState();
      }

      updatePaymentButtonState() {
        if (!this.productForm) return;
        const blocked = this.requiresCustomSize() && !this.input.value.trim();
        this.productForm.classList.toggle('sil-custom-size-required', blocked);
        this.productForm
          .querySelectorAll('.shopify-payment-button button')
          .forEach((button) => {
            button.disabled = blocked;
            button.setAttribute('aria-disabled', String(blocked));
          });
      }

      clearError() {
        this.classList.remove('is-invalid');
        this.input.removeAttribute('aria-invalid');
        if (this.error) this.error.hidden = true;
      }

      validate(event) {
        if (!this.requiresCustomSize() || this.input.value.trim()) return true;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.hidden = false;
        this.classList.add('is-invalid');
        this.input.setAttribute('aria-invalid', 'true');
        if (this.error) this.error.hidden = false;
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => this.input.focus({ preventScroll: true }), 250);
        return false;
      }
    }
  );
}
